import { render, staticRenderFns } from "./ArticleReport.vue?vue&type=template&id=d7fe991e&"
import script from "./ArticleReport.vue?vue&type=script&lang=js&"
export * from "./ArticleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports